import React from "react";
import "./AboutMission.css";

function AboutMission(props) {
  return (
    <div className="AboutMission ">
      <div className="about__mission_container ">
        <div
          id="about__mission_imgcontainer"
          className="about__mission_imgcontainer slow__display"
        >
          <img id="mission__img" src="/img/img-11.jpg" />
        </div>
        <div className="about__mission_descriptioncontainer">
          <div className="mission_descriptioncontainer">
            <h2>Our Mission</h2>
            <p>
              Our mission is to provide sustainable hope for vulnerable children
              and the families who care for them by empowering orphan and
              vulnerable centre workers to become faith-based transformational
              leaders in the communities they serve.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutMission;
